import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import FeatureGrid from "./components/FeatureGrid";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import Testimonials from "./components/Testimonials";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://acbuyspreadsheet.wiki";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "ACBuySpreadsheet",
            alternateName: "ACBuy Spreadsheet System",
            url: siteUrl,
            description:
              "ACBuySpreadsheet is a structured data-driven spreadsheet system designed to help you track orders, compare costs, and optimize your buying process with full transparency.",
            image: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg",
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate: `${siteUrl}/?search={search_term_string}`,
              },
              "query-input": "required name=search_term_string",
            },
            publisher: {
              "@type": "Organization",
              name: "ACBuySpreadsheet",
              url: siteUrl,
              logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "ACBuySpreadsheet",
            url: siteUrl,
            logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg",
            sameAs: ["https://kaspreadsheet.com/"],
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <FeatureGrid />
        <CategoryGrid />
        <CTASection />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}